import { HighlightText } from "@/components/MedicalChronology/HighlightText";
import { FileText } from "lucide-react";
import React from "react";

export interface SummaryAccidentDetailsFieldProps {
  value: string | null | undefined;
  isEditMode: boolean;
  onChange: (value: string) => void;
  placeholder?: string;
  highlightQuery: string;
}

export const SummaryAccidentDetailsField: React.FC<SummaryAccidentDetailsFieldProps> = ({
  value,
  isEditMode,
  onChange,
  placeholder,
  highlightQuery,
}) => {
  const displayValue = value?.trim() ? value : null;

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-center gap-1.5">
        <span className="text-neutral-400">
          <FileText size={12} strokeWidth={2.5} />
        </span>
        <label className="text-2xs font-semibold uppercase tracking-micro text-neutral-500">
          Accident Details
        </label>
      </div>
      {isEditMode ? (
        <textarea
          value={value ?? ""}
          onChange={(e) => onChange(e.target.value)}
          rows={5}
          className="w-full resize-y rounded-lg border border-neutral-200 bg-card px-3 py-2.5 text-dense font-normal leading-relaxed text-neutral-900 shadow-sm transition-all focus-visible:shadow-focus"
          placeholder={placeholder}
        />
      ) : (
        <div className="min-h-[40px]">
          {displayValue ? (
            <p className="whitespace-pre-wrap text-dense font-normal leading-[1.7] text-neutral-700">
              <HighlightText text={displayValue} highlightQuery={highlightQuery} />
            </p>
          ) : (
            <span className="text-dense font-normal italic text-neutral-400">
              {placeholder ?? "—"}
            </span>
          )}
        </div>
      )}
    </div>
  );
};
